import { render, staticRenderFns } from "./ContractBasicInfoTerminationBox.vue?vue&type=template&id=58f60f85&"
import script from "./ContractBasicInfoTerminationBox.vue?vue&type=script&lang=js&"
export * from "./ContractBasicInfoTerminationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports